<template lang="pug">
nav.header
  .row
    .col-md-6
      h1 {{ name }}

    .col-md-6.text-right
      .btn-group
        router-link.btn.btn-prominent.btn-info(
          :to="{ name: routeName }"
          @click.prevent="disableActions"
          :class="{ disabled: disableActions }"
        )
          i.fa.fa-arrow-left
          |
          | Back

        router-link.btn.btn-default(
          :to="{ name: editRouteName, params: { id } }"
          @click.prevent="disableActions"
          :class="{ disabled: disableActions }"
        )
          i.fa.fa-pencil
          |
          | Edit

        template
          button.btn.btn-danger(
            type="button"
            @click.prevent="destroy"
            :disabled="disableActions"
          )
            i.fa.fa-trash
</template>

<script setup>
  // TODO: We should use this new component everywhere it makes sense

  import { computed } from 'vue'
  import { camelCase } from 'lodash'
  import pluralize from 'pluralize'

  const props = defineProps({
    id: {
      type: Number,
      required: false
    },

    routeName: {
      type: String,
      required: false
    },

    name: {
      type: String,
      required: false
    }
  })

  const emit = defineEmits(['destroy'])

  const backRouteName = computed(() => camelCase(pluralize(props.routeName)))
  const editRouteName = computed(() => camelCase(`edit_${pluralize(props.routeName, 1)}`))
  const disableActions = computed(() => !(props.id && props.routeName))

  const destroy = () => {
    emit('destroy')
  }
</script>

<style scoped>
  nav.header {
    margin-bottom: 20px;
    border-bottom: solid 1px #ccc;
  }
</style>
